export default __webpack_public_path__ + "static/media/Fried Chicken Burger - proportioned_170.2ca13e13.jpg";